import React, { useEffect, useState, useRef, useMemo } from 'react';
import './Header.css';
import img1 from './b.jpeg';
import img2 from './b2.jpeg';
import img3 from './b3.jpeg';

function Header() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = useMemo(() => [img1, img2, img3], []);

  const heroRef = useRef(null);

  useEffect(() => {
    // Preload images
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images]);

  useEffect(() => {
    const heroElement = heroRef.current;
    if (!heroElement) return;

    heroElement.classList.add('fade-out');

    const timeout = setTimeout(() => {
      heroElement.style.backgroundImage = `url(${images[currentImageIndex]})`;
      heroElement.classList.remove('fade-out');
      heroElement.classList.add('fade-in');
    }, 500); // Match this with the CSS transition duration

    return () => clearTimeout(timeout);
  }, [currentImageIndex, images]);

  const handleClick = () => {
    window.location.href = 'https://wa.me/message/4CRSU4NUHIXPI1';
  };

  return (
    <>
      <header ref={heroRef} className="hero">
        <div className="overlay">
          <h1 className="hero-title">
            בואו לגלות איך להפוך לשינוי שאתם מבקשים במערכות היחסים שלכם
          </h1>
          <button className="cta-button" onClick={handleClick}>
            צור קשר בקליק
          </button>
        </div>
      </header>
    </>
  );
}

export default Header;
